import * as K from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as X } from "../../utilities/uv.js";
import { transformColor as h } from "../../utilities/transformations.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as x } from "../../helpers/distort.js";
const st = {
  name: "Pearl1",
  collection: "pearl",
  tags: ["blobs", "organic", "prism"],
  props: {
    speed: {
      type: Number,
      description: "The movement speed of the pearl effect.",
      default: 0.15
    },
    colorA: {
      type: String,
      description: "The first color of the foreground.",
      default: "#316d8c",
      transform: h
    },
    colorB: {
      type: String,
      description: "The second color of the foreground.",
      default: "#a57cb5",
      transform: h
    },
    backgroundColor: {
      type: String,
      description: "The background color behind the pearl effect.",
      default: "#a59e9e",
      transform: h
    }
  },
  fragmentNode: (d) => {
    const {
      vec2: u,
      vec3: D,
      vec4: S,
      time: a,
      length: I,
      sin: r,
      cos: i,
      smoothstep: f,
      float: t,
      add: N,
      PI: p,
      mix: E,
      min: R,
      pow: P
    } = K, C = 5, s = t(0.5), l = t(0.075), A = 1, U = t(0.25), B = t(1), y = 0.2, F = 1, L = t(1), M = t(1), { correctedUV: g, correctedCenter: k } = X(), v = g.sub(k), V = (o) => {
      const e = a.mul(t(3).mul(d.speed.uniform)).add(t(A).mul(100)), n = u(
        r(e.mul(0.23).add(t(o).mul(1.7))),
        i(e.mul(0.37).add(t(o).mul(1.3)))
      ).mul(0.3), c = u(
        r(e.mul(0.17).add(t(o).mul(2.3))),
        i(e.mul(0.29).add(t(o).mul(1.9)))
      ).mul(0.1);
      return n.add(c);
    }, Y = (o = u(0), m, e) => {
      const n = I(o.sub(m)), c = a.mul(0.5), O = c.add(t(e).mul(p.mul(0.5))), Z = u(
        i(O),
        r(O.add(r(c.mul(0.3))))
        // Add oscillation to direction
      ), j = x(o, y, F, A), q = o.sub(Z.mul(B)).mul(j), z = I(q.sub(m)), J = r(
        n.mul(3).add(a.mul(0.7).mul(d.speed.uniform)).add(t(e).mul(2.5))
      ).mul(U);
      return n.add(J).mul(0.15).add(z.mul(0.05));
    };
    let b = t(0), _ = t(0);
    for (let o = 0; o < C; o++) {
      const m = V(o), e = Y(v, m, o), n = f(
        l.add(s),
        l.sub(s),
        e.mul(6)
        // Increased multiplier for sharper transition
      ).mul(t(C).greaterThan(o)), c = f(
        l.add(s.mul(1.2)),
        l.add(s.mul(0.8)),
        e.mul(7)
      ).sub(
        f(
          l.sub(s.mul(0.8)),
          l.sub(s.mul(1.2)),
          e.mul(7)
        )
      );
      b = N(b, n), _ = N(_, c);
    }
    const w = $(1)(g).mul(0.7), T = _.mul(L), H = D(
      r(T.mul(2)).add(1).mul(0.5),
      r(T.mul(2.2).add(p.mul(0.33))).add(1).mul(0.5),
      r(T.mul(2.4).add(p.mul(0.66))).add(1).mul(0.5)
    ), W = E(d.colorA.uniform, d.colorB.uniform, g.x), G = S(
      W.mul(H),
      1
    ), Q = E(
      d.backgroundColor.uniform,
      G,
      P(R(b.mul(1.2), 0.8), M)
      // Sharper transition
    ).sub(w.mul(0.6));
    return S(Q);
  }
};
export {
  st as componentDefinition,
  st as default
};
